import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useProductErrors } from '../contexts/ProductErrorContext';
import { useIsProductLoading } from '../contexts/ProductLoadingContext';
import { ProductHighlightActions } from './ProductHighlightActions';
import ProductHighlightHeader from './ProductHighlightHeader';
import { ProductHighlightModals } from './ProductHighlightModals';
import { useProductData } from '../contexts/ProductDataContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductHighlightContent = () => {
  const loading = useIsProductLoading();
  const errors = useProductErrors();
  const productData = useProductData();
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-test-id": "product-highlight-card-content-loading",
      grow: true,
      layout: "centered"
    });
  }
  if (errors.length > 0 || productData === undefined) {
    throw new Error('Error fetching product pricing info', {
      cause: errors
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ProductHighlightModals, {}), /*#__PURE__*/_jsx(ProductHighlightActions, {}), /*#__PURE__*/_jsx(ProductHighlightHeader, {})]
  });
};